import { getV1CompaniesCompanyIdLocationHistoriesLatest } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import connection from '~services/connectionModule';

import { NextBillionAssetLocation } from './models';

interface GetLatestLocationsParams {
  order_id?: string;
  job_id?: string;
  companyId: string;
}

export const useNextBillionAssetLocationHistories = () => {
  const getLatestLocations = async ({
    order_id,
    job_id,
    companyId,
  }: GetLatestLocationsParams) => {
    try {
      const response = await getV1CompaniesCompanyIdLocationHistoriesLatest({
        path: { 'company-id': companyId },
        query: {
          ...(order_id ? { 'filter[order_id]': order_id } : {}),
          ...(job_id ? { 'filter[job_id]': job_id } : {}),
        },
      });
      return {
        data: response.data.data.map(NextBillionAssetLocation.parse),
      };
    } catch (error) {
      connection.handleRequestError(
        error,
        t('error_messages.next_billion.failed_to_fetch'),
      );
    }
  };

  return {
    getLatestLocations,
  };
};
